import React from "react"

import {Button, Box, Grid, Typography, Stack} from '@mui/material'
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';

const OutboundSamlLink = (props) => {
    const HealthToolsFrame = props.HealthToolsFrame
    const {Image, List, Subtitle, Title, Visible} = HealthToolsFrame
    const {URL, Text } = HealthToolsFrame.Button

    return (
                <Grid container direction="row" alignItems="top" justifyContent="center" spacing={3}>
                    <Grid item xs={12} md={8}>
                        <Box pb={2}>
                            <Typography variant="h5" gutterBottom>{Title}</Typography>
                        </Box>
                        <Typography variant="body1">{Subtitle}</Typography>
                        <Box pl={3}>

                        {
                            List.split('|').map(x=>{
                                return (<Typography variant="body1">-{"\t"} {x}</Typography>)
                            })
                        }
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Stack direction={"column"} gap={2}>

                            <Box px={3} display="flex" margin={'auto'}>
                                <img src={"../"+Image+"/"} style={{objectFit:"contain"}}/>
                            </Box>
                             <Button variant="contained" href={"../../../WsWebAppWellsuite/" + props.link} fullWidth>{Text}</Button>
                        </Stack>

               
                    </Grid>
                </Grid >
    )
}

export default OutboundSamlLink; 